/**
 * 主题同步：给 <html> 加/去 `.dark`，与 index.css 的 `@custom-variant dark` 对应。
 *
 * 纯 SPA 不需要 next-themes 的 SSR 防闪烁脚本（它会在 React 里注入 <script> 并报错），
 * 所以自己管：默认跟随系统，App 内则用 `app.info.theme` 覆盖。
 */

export type ThemePreference = 'light' | 'dark' | 'system';

const media = typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null;
let preference: ThemePreference = 'system';

function resolved(): 'light' | 'dark' {
  if (preference === 'system') return media?.matches ? 'dark' : 'light';
  return preference;
}

function apply(): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', resolved() === 'dark');
}

/** 页面启动时调一次；跟随系统偏好变化。 */
export function installThemeSync(): void {
  apply();
  media?.addEventListener('change', apply);
}

/** App 内由 `app.info.theme` 覆盖；传 'system' 可恢复跟随系统。 */
export function setThemePreference(next: ThemePreference): void {
  preference = next;
  apply();
}

export function currentResolvedTheme(): 'light' | 'dark' {
  return resolved();
}
